import { ActionContext } from "vuex";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

import PushNotificationService from "@/App/services/PushNotification.Service";
import { Storage as storage } from "@/App/services/LocalStorage";

const firebaseConf = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_FIREBASE_APPID,
};

const state = getDefaultState();

function getDefaultState() {
  return {
    registrationToken: storage.getItem("registrationToken") || null,
    messaging: undefined,
    serviceWorkerRegistration: undefined,
  };
}

const getters = {
  registrationToken: (state: any) => state.registrationToken,
  messaging: (state: any) => state.messaging,
};

const actions = {
  init(context: ActionContext<any, any>, registration: ServiceWorkerRegistration) {
    const app = initializeApp(firebaseConf);
    context.state.messaging = getMessaging(app);
    context.state.serviceWorkerRegistration = registration;

    if (registration.active) {
      registration.active.postMessage({
        action: "initializeFirebase",
        payload: { config: firebaseConf },
      });
    }
  },
  requestToken(context: ActionContext<any, any>) {
    const { messaging, serviceWorkerRegistration } = context.state;
    if (messaging) {
      const successHandler = (token) => {
        context.commit("SET_FIREBASE_TOKEN", token);
      };
      const failureHandler = (error) => {
        console.error("unable to get firebase token", error);
      };
      getToken(messaging, {
        vapidKey: process.env.VUE_APP_FIREBASE_PUBLICVAPIDKEY,
        serviceWorkerRegistration,
      }).then(successHandler).catch(failureHandler);
    }
  },
  subscribe(context: ActionContext<any, any>, topic: string) {
    if (context.state.registrationToken && topic) {
      PushNotificationService.subscribe(context.state.registrationToken, topic);
    }
  },
  unsubscribe(context: ActionContext<any, any>, topic: string) {
    if (context.state.registrationToken && topic) {
      PushNotificationService.unsubscribe(context.state.registrationToken, topic);
    }
  },
  resetState({ commit }: any) {
    commit("RESET_STATE");
  },
};

const mutations = {
  SET_FIREBASE_TOKEN(state: any, registrationToken: string) {
    state.registrationToken = registrationToken;
    storage.setItem("registrationToken", registrationToken);
  },
  RESET_STATE(state: any) {
    const initialState: any = getDefaultState();

    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key];
    });
  },
};

const store = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default store;
